import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import api from '../../utils/api/api';
import { API_CONTEST_SEND_MEDIA } from '../../utils/api/constants';

interface UploadPDFData {
  file: File;
  contestId: string;
  title: string;
}

export const useUploadContestPDF = (): UseMutationResult<void, Error, UploadPDFData, unknown> => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UploadPDFData>(
    ({ file, contestId, title }) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('contestId', contestId);
      formData.append('title', title);

      return api
        .post(API_CONTEST_SEND_MEDIA, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => res.data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('contests');
        queryClient.invalidateQueries('contest');
        queryClient.invalidateQueries('activeContest');
      },
    },
  );
};
